export default "__VITE_ASSET__BiA88Vlx__"